// The mark: one torn crumb. Breadcrumbs plus CRM is the name, and a single piece
// says it without the trail-of-dots reading as a chart icon. Chosen over four
// other candidates because it is the only silhouette that survives 16px in a tab,
// which is where this spends most of its life.
//
// Deliberately not a regular hexagon — the six corners sit on uneven edges so it
// reads as something torn rather than drawn. The same geometry ships as the
// favicon in `public/icon.svg`; keep the two in step.
//
// One closed path, no stroke: it scales, inverts and stamps flat in a single ink,
// which it has to, because on a client report it sits in the customer's palette.

const CRUMB =
  'M27.7 5.8Q29.5 4 31.8 5.1L50.8 14.1Q53.1 15.2 53.8 17.6L59.1 37.3Q59.8 39.7 58.1 41.5L43.6 56.9Q41.9 58.7 39.4 58.3L18.8 54.6Q16.3 54.2 15.2 52L5.1 31.7Q4 29.5 5.8 27.7Z'

export function Mark({ size = 18 }: { size?: number }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} fill="currentColor" aria-hidden>
      <path d={CRUMB} />
    </svg>
  )
}

/** The mark in its warm tile, as it appears in the header and the loading skeleton. */
export function Brand({ size = 28 }: { size?: number }) {
  return (
    <span
      className="flex shrink-0 items-center justify-center"
      style={{
        width: size,
        height: size,
        // A squircle rather than a rounded-inline rect — softer at this size.
        borderRadius: '30%',
        background: 'color-mix(in srgb, var(--accent) 16%, transparent)',
        color: 'var(--accent)',
      }}
    >
      <Mark size={size * 0.64} />
    </span>
  )
}
